import React from 'react';

function AcceptInvite(props) {
    return (
        <div></div>
    );
}

export default AcceptInvite;